'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _components = require('components');

var _oldCFA = require('redux/modules/GenericSettings/oldCFA');

var mapDispatchToProps = {
    deleteInput: _oldCFA.deleteInputUI
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_components.DeleteInput);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/DeleteInput/DeleteInput.js
// module id = 1625
// module chunks = 0